/**
 * External dependencies
 */
// import { registerPlugin } from '@wordpress/plugins';
// const render = () => {};

// registerPlugin('save-share-cart', {
// 	render,
// 	scope: 'woocommerce-checkout',
// });